<template>
    <div style="overflow-x: hidden; overflow-y: auto; height: 100%">
        <div class="page_header">
            <span class="page_title">{{ $t('maintenanceReminder.维保重置记录') }}</span>
            <el-form :inline="true" size="small" style="flex:1; text-align: right">
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">{{ $t('public.add') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-divider></el-divider>

        <div class="page_container">
            <el-table :data="tableData" v-loading="loading" stripe style="width: 100%">
                <el-table-column type="index" :label="$t('public.index')" align="center" width="60"></el-table-column>
                <el-table-column prop="CarNo" align="center" :label="$t('maintenanceReminder.车牌号')" min-width="120"></el-table-column>
                <el-table-column prop="ResetTime" align="center" :label="$t('maintenanceReminder.重置时间')" min-width="160"></el-table-column>
                <el-table-column prop="ResetMileage" align="center" :label="$t('maintenanceReminder.重置里程')" min-width="120"></el-table-column>
                <el-table-column prop="ResetParts" align="center" :label="$t('maintenanceReminder.重置的零部件')" min-width="180">
                    <template slot-scope="scope">{{ joinParts(scope.row.ResetParts) }}</template>
                </el-table-column>
                <el-table-column prop="Location" align="center" :label="$t('maintenanceReminder.位置信息')" min-width="160">
                    <template slot-scope="scope">{{ scope.row.Location || '-' }}</template>
                </el-table-column>
                <el-table-column prop="Remark" align="center" :label="$t('maintenanceReminder.备注信息')" min-width="180">
                    <template slot-scope="scope">{{ scope.row.Remark || '-' }}</template>
                </el-table-column>
                <el-table-column align="center" :label="$t('public.Operation')" min-width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleEdit(scope.row)">
                            {{ $t('public.edit') }}
                        </el-button>
                        <el-button type="text" size="small" style="color:#f56c6c" @click="handleDelete(scope.row)">
                            {{ $t('public.del') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <kl-pagination style="margin-bottom: 10px" :pageSize="PageSize" :total="total" @current-change="pageChange"
                :current-page.sync="PageNo" @size-change="sizeChange"></kl-pagination>
        </div>

        <!-- 新增 / 编辑弹窗 -->
        <ResetRecordDialog :visible.sync="dialogVisible" :record="currentRecord" @submit="handleSubmit" />
    </div>
</template>

<script>
import { queryResetRecord, addResetRecord, updateResetRecord, deleteResetRecord } from './mockData'
import ResetRecordDialog from './ResetRecordDialog.vue'

export default {
    name: 'MaintenanceResetRecord',
    components: { ResetRecordDialog },
    data() {
        return {
            tableData: [],
            loading: false,
            PageNo: 1,
            PageSize: 10,
            total: 0,
            dialogVisible: false,
            currentRecord: {}
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            queryResetRecord({ PageNo: this.PageNo, PageSize: this.PageSize }).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.tableData = res.data || []
                    this.total = res.count || 0
                }
            })
        },
        sizeChange(size) {
            this.PageSize = size
            this.loadData()
        },
        pageChange(page) {
            this.PageNo = page
            this.loadData()
        },
        joinParts(parts) {
            if (Array.isArray(parts)) return parts.join(',')
            return parts || '-'
        },
        handleAdd() {
            this.currentRecord = {}
            this.dialogVisible = true
        },
        handleEdit(row) {
            this.currentRecord = { ...row }
            this.dialogVisible = true
        },
        handleDelete(row) {
            this.$confirm(this.$t('maintenanceReminder.确认删除该重置记录吗'), this.$t('maintenanceReminder.删除确认'), {
                confirmButtonText: this.$t('public.confirm'),
                cancelButtonText: this.$t('public.cancel'),
                type: 'warning'
            }).then(() => {
                deleteResetRecord(row.RecordID).then(res => {
                    if (res.code === 200) {
                        this.$message.success(this.$t('public.hasDeleted'))
                        this.loadData()
                    }
                })
            }).catch(() => { })
        },
        // 新增或修改：根据当前记录是否含 RecordID 区分
        handleSubmit(form) {
            if (this.currentRecord.RecordID) {
                updateResetRecord({ RecordID: this.currentRecord.RecordID, ...form }).then(res => {
                    if (res.code === 200) {
                        this.dialogVisible = false
                        this.$message.success(this.$t('public.edit_success'))
                        this.loadData()
                    }
                })
            } else {
                addResetRecord(form).then(res => {
                    if (res.code === 200) {
                        this.dialogVisible = false
                        this.$message.success(this.$t('maintenanceReminder.重置记录添加成功'))
                        this.loadData()
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
</style>